import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;

export const INIT = `${SCOPE}/INIT`;

export const SET_INTERVAL = `${SCOPE}/SET_INTERVAL`;
export const SET_METRIC = `${SCOPE}/SET_METRIC`;
export const SET_CODE = `${SCOPE}/SET_CODE`;
export const SET_FILTER = `${SCOPE}/SET_FILTER`;

export const SET_CURRENT_ERROR_CODE = `${SCOPE}/SET_CURRENT_ERROR_CODE`;
export const SET_ERROR_CODE_SELECTED = `${SCOPE}/SET_ERROR_CODE_SELECTED`;
export const ADD_ERROR_CODE = `${SCOPE}/ADD_ERROR_CODE`;
export const REMOVE_ERROR_CODE = `${SCOPE}/REMOVE_ERROR_CODE`;

export const SET_BASE_STATE = `${SCOPE}/SET_BASE_STATE`;
